"use client";

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { clearFormFieldErrorForInstance } from "./formFieldErrorStore";
import { type FormFieldProps, renderFormConsentPublic, renderFormFieldFromContainerProps } from "./formPublicShared";
import { usePublicFormFieldError } from "./formPublicValidationContext";
type FieldDom = {
  className?: string;
  id?: string;
  "data-pb-node"?: string;
};
export function PublicFormField(t0) {
  const $ = _c(13);
  const {
    id,
    props,
    style,
    wrapperDom,
    formInstanceId
  } = t0;
  let t1;
  if ($[0] !== props.__ffName) {
    t1 = (props.__ffName || "field").trim() || "field";
    $[0] = props.__ffName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = t1;
  const fieldError = usePublicFormFieldError(formInstanceId, name);
  let t2;
  if ($[2] !== fieldError || $[3] !== formInstanceId || $[4] !== name) {
    t2 = formInstanceId && fieldError ? () => clearFormFieldErrorForInstance(formInstanceId, name) : undefined;
    $[2] = fieldError;
    $[3] = formInstanceId;
    $[4] = name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onFieldInteraction = t2;
  let t3;
  if ($[6] !== fieldError || $[7] !== id || $[8] !== onFieldInteraction || $[9] !== props || $[10] !== style || $[11] !== wrapperDom) {
    t3 = renderFormFieldFromContainerProps(id, props, style, wrapperDom, {
      fieldError,
      onFieldInteraction
    });
    $[6] = fieldError;
    $[7] = id;
    $[8] = onFieldInteraction;
    $[9] = props;
    $[10] = style;
    $[11] = wrapperDom;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export function PublicFormConsent(t0) {
  const $ = _c(13);
  const {
    id,
    props,
    style,
    dom,
    formInstanceId
  } = t0;
  let t1;
  if ($[0] !== props.__fcName) {
    t1 = (props.__fcName || "consent").trim() || "consent";
    $[0] = props.__fcName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = t1;
  const fieldError = usePublicFormFieldError(formInstanceId, name);
  let t2;
  if ($[2] !== fieldError || $[3] !== formInstanceId || $[4] !== name) {
    t2 = formInstanceId && fieldError ? () => clearFormFieldErrorForInstance(formInstanceId, name) : undefined;
    $[2] = fieldError;
    $[3] = formInstanceId;
    $[4] = name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onFieldInteraction = t2;
  let t3;
  if ($[6] !== dom || $[7] !== fieldError || $[8] !== id || $[9] !== onFieldInteraction || $[10] !== props || $[11] !== style) {
    t3 = renderFormConsentPublic(id, props, style, dom, {
      fieldError,
      onFieldInteraction
    });
    $[6] = dom;
    $[7] = fieldError;
    $[8] = id;
    $[9] = onFieldInteraction;
    $[10] = props;
    $[11] = style;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}